import { C } from "./theme";

/*
 * Fluxo profissional de produção — fonte única de verdade para status de pedido.
 *
 * Compatível com dados antigos: pedidos salvos com "Pendente", "Pronto" etc.
 * (aba Pedidos) ou "pago", "em_entrega" etc. (loja online) são normalizados
 * para um id canônico via normalizarStatus(), sem precisar migrar o banco.
 * Ao salvar uma mudança de status, gravamos sempre o id canônico.
 */

export const STATUS_PEDIDO = [
  { id:"conferindo_pagamento", label:"Conferindo pagamento", curto:"Pagamento",  icone:"💳", cor:"#f59e0b" },
  { id:"aguardando_impressao", label:"Aguardando impressão", curto:"Aguardando", icone:"⏳", cor:C.warning },
  { id:"imprimindo",           label:"Imprimindo",           curto:"Imprimindo", icone:"🖨️", cor:C.accent2 },
  { id:"concluido",            label:"Concluído",            curto:"Concluído",  icone:"✅", cor:"#22c55e" },
  { id:"pronto_entrega",       label:"Pronto para entrega",  curto:"Pronto",     icone:"📦", cor:"#10b981" },
  { id:"entregue",             label:"Entregue",             curto:"Entregue",   icone:"🚚", cor:"#06b6d4" },
  { id:"cancelado",            label:"Cancelado",            curto:"Cancelado",  icone:"✖️", cor:C.danger },
];

const POR_ID = Object.fromEntries(STATUS_PEDIDO.map(s => [s.id, s]));

// valores legados (aba Pedidos) e da loja (pedidos_online) -> id canônico
const ALIAS = {
  pendente:"aguardando_impressao",
  imprimindo:"imprimindo",
  pronto:"pronto_entrega",
  entregue:"entregue",
  concluido:"concluido",
  cancelado:"cancelado",
  pagamento_em_analise:"conferindo_pagamento",
  pago:"aguardando_impressao",
  em_entrega:"entregue",
};

export function normalizarStatus(valor) {
  if (!valor) return "aguardando_impressao";
  const v = String(valor).trim();
  if (POR_ID[v]) return v;                 // já é canônico
  return ALIAS[v.toLowerCase()] || "aguardando_impressao";
}

export function statusInfo(valor) {
  return POR_ID[normalizarStatus(valor)] || STATUS_PEDIDO[1];
}

// Próximo passo do fluxo linear (ignora "cancelado"); null se já no fim/cancelado
export function proximoStatus(valor) {
  const id = normalizarStatus(valor);
  if (id === "cancelado") return null;
  const seq = STATUS_PEDIDO.filter(s => s.id !== "cancelado");
  const j = seq.findIndex(s => s.id === id);
  return j >= 0 && j < seq.length - 1 ? seq[j + 1].id : null;
}

// Loja com pagamento online (Mercado Pago): o pedido só vale depois que o
// servidor confirmar o pagamento. Até lá — ou se o cliente desistiu — ele não
// aparece para a loja (Pedidos, loja online, avisos) nem em "Meus pedidos".
export const STATUS_CHECKOUT_ONLINE = ["aguardando_pagamento", "pagamento_nao_concluido"];
export const pedidoOnlineOculto = p => STATUS_CHECKOUT_ONLINE.includes(p?.status);

// canônico -> status visível ao cliente na loja (pedidos_online)
const PARA_ONLINE = {
  conferindo_pagamento:"pagamento_em_analise",
  aguardando_impressao:"pago",
  imprimindo:"imprimindo",
  concluido:"pronto",
  pronto_entrega:"pronto",
  entregue:"concluido",
  cancelado:"cancelado",
};

export function statusParaOnline(valor) {
  return PARA_ONLINE[normalizarStatus(valor)] || "pago";
}

// "Concluído" na loja significa entrega finalizada; na produção significa
// apenas impressão terminada. Não use o normalizador genérico nesse retorno.
export function statusDoOnline(valor, statusGestaoAtual) {
  const online = String(valor || "").trim().toLowerCase();
  if (statusGestaoAtual && statusParaOnline(statusGestaoAtual) === online) {
    return normalizarStatus(statusGestaoAtual);
  }
  const mapa = {
    pagamento_em_analise: "conferindo_pagamento", pago: "aguardando_impressao",
    imprimindo: "imprimindo", pronto: "pronto_entrega", em_entrega: "pronto_entrega",
    concluido: "entregue", cancelado: "cancelado",
  };
  return mapa[online] || normalizarStatus(valor);
}
